export const SET_SEDE = 'SET_SEDE';
export const SET_SEDI_PAGEABLE = 'SET_SEDI_PAGEABLE';
